import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

import { memo, useMemo, useCallback } from 'react'

import { useResponsive } from 'hooks/useResponsive'
import { useDropdownState } from 'hooks/useDropdownState'
import TtsVelocityToggler from './Components/Toggler'
import TtsVelocityContent from './Web'
import MobileTtsVelocity from './Mobile'
import * as Styled from './styled'
import { useMobileInnerSliderCallbacks } from 'hooks/useMobileInnerSliderCallbacks'

interface IProps {
  isBulkMode?: boolean
  initialValue: number | string
  onClick: (value: number) => void
  scrollableParentRef?: React.RefObject<HTMLDivElement | null>
}
const SpeakerVelocity: React.FC<IProps> = (props: IProps) => {
  const {
    isBulkMode = false,
    initialValue,
    onClick,
    scrollableParentRef
  } = props

  const isTablet = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)

  const { openCallback, closeCallback } = useMobileInnerSliderCallbacks()

  const { isOpen, toggleDropdown, closeDropdown } = useDropdownState(
    openCallback,
    closeCallback
  )

  const onValueClick = useCallback(
    (value: number) => {
      if (value !== initialValue) {
        onClick(value)
      }
      closeDropdown()
    },
    [initialValue, onClick, closeDropdown]
  )

  const headerContent = useMemo(
    () => (
      <TtsVelocityToggler
        isBulkMode={isBulkMode}
        toggleVelocityContent={toggleDropdown}
        ttsSpeed={initialValue}
        scrollableParentRef={scrollableParentRef}
      />
    ),
    [isBulkMode, toggleDropdown, initialValue, scrollableParentRef]
  )

  const mainContent = useMemo(() => {
    return (
      <TtsVelocityContent
        selectedValue={initialValue}
        handleValueClick={onValueClick}
      />
    )
  }, [initialValue, onValueClick])

  if (isTablet && isOpen) {
    return (
      <MobileTtsVelocity
        closeVelocityContent={closeDropdown}
        selectedValue={initialValue}
        handleValueClick={onValueClick}
        isOpen={isOpen}
        onClose={closeDropdown}
      />
    )
  }

  return (
    <Styled.DropdownWrapper
      $isBulkMode={isBulkMode}
      headerContent={headerContent}
      mainContent={mainContent}
      isOpen={isOpen}
      toggleDropdown={toggleDropdown}
      closeDropdown={closeDropdown}
      scrollableParentRef={scrollableParentRef}
      hasTogglerArrow={false}
    />
  )
}

export default memo(SpeakerVelocity)
